import { Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FileUpload } from 'primeng/fileupload';
import { PageInfo } from 'src/app/core/models/page-info';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { StockMaintenanceService } from '../../../service/stock-maintenance.service';

@Component({
  selector: 'laas-stock-maintenance-import',
  templateUrl: './stock-maintenance-import.component.html',
  styleUrls: ['./stock-maintenance-import.component.scss']
})
export class StockMaintenanceImportComponent extends SessionBaseComponent implements OnInit {

  isVisible: boolean = false;
  isLoading: boolean = false;
  isSaveing:boolean = false;
  pageInfo: PageInfo;

  trackingItemRows: any[] = [];
  tableColumns: any[];

  @Output() visibleChange: EventEmitter<any>;
  @ViewChild('fileUpload') fileUpload!: FileUpload;


  constructor(
    private injector: Injector,
    private stockMaintenanceService: StockMaintenanceService
  ) {
    super(injector);

    this.pageInfo = {
      pageSize: 5,
      pageIndex: 0,
      totalRecords: 0,
      totalPages: 0,
    };

    this.tableColumns = [
      { field: 'uId', header: 'StockMaintenance.MainTable.Column.uId', sort: false },
      { field: 'sku', header: 'StockMaintenance.MainTable.Column.sku', sort: false },
      { field: 'trackingItemsNotes', header: 'StockMaintenance.MainTable.Column.trackingItemsNotes', sort: false },
      { field: 'destockingDate', header: 'StockMaintenance.MainTable.Column.destockingDate', dataType: 'date', sort: false },
      { field: 'userId', header: 'StockMaintenance.MainTable.Column.createUser', sort: false }
    ];

    this.visibleChange = new EventEmitter<any>();
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
  }

  @Input() get visible(): any {
    return this.isVisible;
  }

  set visible(value: any) {
    this.isVisible = value;
  }

  /**
   * 上傳檔案
   *
   * @param event
   * @returns
   */
  fileUploader(event: any): void {
    let files: any = event?.files;
    if (!files || files.length === 0) {
      this.toastService.warn(this.translateService.instant('TrackingItemImport.Message.SelectFile'));
      return;
    }

    // Reset table
    this.trackingItemRows = [];
    this.pageInfo = {
      pageSize: 5,
      pageIndex: 0,
      totalRecords: 0,
      totalPages: 0,
    };

    // Upload file
    this.isLoading = true;
    this.stockMaintenanceService.importTrackingItemExcelBy(files[0], this.laasSetting.facility, this.userProfile.loginAccount)
    .subscribe({
        next: (result) => {
          const isSuccess = result.success;

          if (!isSuccess) {
            this.toastErrorMessage(result.message);
            return;
          }

          const trackingItems = result.trackingItems;

          // 更改總數量 value
          this.pageInfo.totalRecords = trackingItems?.length || 0;
          this.pageInfo.pageSize = this.pageInfo.totalRecords || 5;

          // Table data
          this.trackingItemRows = trackingItems || [];
        },
        error: (err) => {
          this.toastErrorMessage(err.error);
        },
        complete: () => {
          this.isLoading = false;
          this.fileUpload.clear();
        }
      }
    );
  }

  /**
   * Button 儲存
   *
   * @param event
   * @returns
   */
  saveBtnClick(event: any): void {

    if (!this.trackingItemRows || this.trackingItemRows.length === 0) {
      return;
    }

    const saveParameter = {
      iTrackingItems: this.trackingItemRows
    };
    this.isSaveing=true;
    this.stockMaintenanceService.saveTrackingItem(saveParameter)
      .subscribe({
        next: (result) => {
          const isSuccess = result.success;

          if (!isSuccess) {
            this.toastErrorMessage(result.message);
            return;
          }

          this.toastService.info(result.message);
          this.dialogVisibleChange(false); // Close file upload dialog
        },
        error: (err) => {
          this.toastErrorMessage(err.error);
        },
        complete: () => {
          this.isSaveing=false;
        }
      });
  }

  /**
   * Close file upload dialog
   *
   * @param value
   */
  dialogVisibleChange(value: boolean): void {
    this.visibleChange.emit(value);
  }
}
